import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id/')({
  validateSearch: zodValidator(withDefaults(schema.REPORTS, defaultFilter)),
});
